import { INSTRUCTOR_SCHOOLS, LANGUAGES, TERRAINS } from "../constants/searchConstants"
import { InteractionStatus } from "../types/types"

/**
 * Method to get the Terrain type of the given index
 * @param terrainIndex Index of the terrain in the terrains const array, can be a number or a number as a string
 */
export function getTerrainString(terrainIndex: number | string): string {
	let terrainStr: string = ''

	if (TERRAINS[Number(terrainIndex)]) {
		terrainStr = TERRAINS[Number(terrainIndex)]
	}

	return terrainStr
}

/**
 * Method to get the Language of the given index
 * @param languageIndex Index of the language in the languages const array, can be a number or a number as a string
 */
export function getLanguageString(languageIndex: number | string): string {
	let languageStr: string = ''

	if (LANGUAGES[Number(languageIndex)]) {
		languageStr = LANGUAGES[Number(languageIndex)]
	}

	return languageStr
}

/**
 * Method to get the School Name of the given index
 * @param schoolIndex Index of the school in the schools const array, can be a number or a number as a string
 */
export function getSchoolString(schoolIndex: number | string): string {
	let schoolStr: string = ''

	if (INSTRUCTOR_SCHOOLS[Number(schoolIndex)]) {
		schoolStr = INSTRUCTOR_SCHOOLS[Number(schoolIndex)]
	}

	return schoolStr
}


export function getBookingStatusLabel(status: string): string {
	if (status === InteractionStatus.PAYMENT_IN_PROGRESS) {
		return 'Payment In Progress'
	} else if (status === InteractionStatus.PAYMENT_FAILED) {
		return 'Payment Failed'
	} else if (status === InteractionStatus.ACTIVE) {
		return 'Active'
	} else if (status === InteractionStatus.COMPLETE) {
		return 'Complete'
	} else if (status === InteractionStatus.FLAGGED) {
		return 'Flagged'
	} else if (status === InteractionStatus.REVIEW) {
		return 'Waiting for Review'
	} else if (status === InteractionStatus.WAITING_FOR_VIDEOS) {
		return 'Waiting for Video'
	} else {
		return 'UNKNOWN'
	}
}